$(function () {
    $(document)
        .on('click', ".permanent-disabled", function (e) {
            e.preventDefault();
            var _this = $(this);
            var tagName = _this.prop("tagName").toLowerCase();
            _this.prop('disabled', true)
                .addClass('disabled');
            if (tagName === 'a') {
                _this.attr('link-href', _this.prop('href'))
                    .prop('href', '#');
                window.location.href = _this.attr('link-href');
            } else {
                _this.closest('form').submit();
            }
        })
        .on('click', ".temporary-disabled", function (e) {
            e.preventDefault();
            var _this = $(this);
            var tagName = _this.prop("tagName").toLowerCase();
            _this.prop('disabled', true)
                .addClass('disabled');
            if (tagName === 'a') {
                _this.attr('link-href', _this.prop('href'))
                    .prop('href', '#');
                window.location.href = _this.attr('link-href');
            } else {
                _this.closest('form').submit();
            }
            setTimeout(function () {
                _this.removeAttr('disabled').removeClass('disabled');
                if (_this.is("#addressSubmit")) {
                    ACC.address.updateAddressSubmit();
                }
                if (tagName === 'a') {
                    _this.attr('href', _this.prop('link-href'));
                }
            }, ACC.config.timeToActivateButtons || 3000);
        })
});
